import Image from './image'
import UserQuestion from './user_question'
import Chapter from './chapter'
import Lesson from './lesson'
import Exam from './exam'
import Review from './review'

export default class Course {
  readonly id: number
  readonly name: string
  readonly description: string
  readonly image: Image
  readonly skillList: string[]
  readonly typeIs: string
  readonly price: number
  readonly purchasePrice: number

  readonly purchaseTax: number
  readonly chapters: Chapter[]
  readonly lessons: Lesson[]
  readonly createdAt: string
  readonly firstLessonId: number
  readonly isUseCoupon: boolean
  readonly stripePublishableKey: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.typeIs = data.typeIs
    this.price = data.price
    this.purchasePrice = data.purchasePrice

    this.purchaseTax = data.purchaseTax
    this.skillList = data.skillList
    this.createdAt = data.createdAt
    this.firstLessonId = data.firstLessonId
    this.isUseCoupon = data.isUseCoupon
    this.stripePublishableKey = data.stripePublishableKey

    if (data.image) {
      this.image = new Image(data.image)
    }
    if (data.chapters) {
      this.chapters = data.chapters.map(element => new Chapter(element))
    }
    if (data.lessons) {
      this.lessons = data.lessons.map(element => new Lesson(element))
    }
  }

}
